const isProd = import.meta.env.PROD;

declare global {
  interface Window {
    TrackJS?: {
      track: (error: Error | object | string) => void;
    };
  }
}

type ConsoleLogger = Pick<Console, "error" | "info" | "log" | "warn">;

export function buildLogger(isProd: boolean): ConsoleLogger {
  const prodLogger: ConsoleLogger = {
    error: (error: Error | object | string) => window.TrackJS?.track(error),
    info: () => {},
    log: () => {},
    warn: () => {},
  };

  const notProdLogger: ConsoleLogger = { ...console };

  const clientLogger = isProd ? prodLogger : notProdLogger;

  if (isProd) {
    // eslint-disable-next-line no-warning-comments
    // eslint-disable-next-line no-console
    console.info(
      "[clientLogger]: Only errors are sent to TrackJS. Every other log level is not logged.",
    );
  }

  return clientLogger;
}

const clientLogger = buildLogger(isProd);

/**
 * @description Client logger
 * This is a wrapper around the console object that is used to log messages to the console.
 * In production, it will forward errors to TrackJS.
 * This should be used instead of console.log, console.error, etc in client side code.
 */
export default clientLogger;
